/**
 * Resilient theme boot helpers — one failed init must not block the rest.
 */
(function () {
  'use strict';

  function safeRun(label, fn) {
    try {
      return fn();
    } catch (err) {
      if (window.console && typeof console.warn === 'function') {
        console.warn('[YT theme]', label, err);
      }
      return undefined;
    }
  }

  window.YTSafeRun = safeRun;

  function isNarrow() {
    return window.matchMedia && window.matchMedia('(max-width: 798px)').matches;
  }

  safeRun('rimg', function () {
    if (isNarrow()) return;
    if (document.body && /\bcollection/.test(document.body.className || '')) return;
    if (window.rimg && window.rimg.shopify && typeof window.rimg.shopify.init === 'function') {
      window.rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });
    }
  });

  safeRun('sectionsManager', function () {
    if (typeof ShopifySectionsManager === 'undefined') return;

    var sections = new ShopifySectionsManager();
    sections.register('age-gate', function (section) {
      return new AgeGate.PageAgeGate(section);
    });

    var ageGatePage = document.getElementById('age-gate-page');
    if (ageGatePage) {
      new AgeGate.SiteAgeGate(ageGatePage);
    }
  });

  var LAZY_SKIP = '.drawer, .modal, .fancybox-container, [data-quickshop], #age-gate-page, .mega-menu, .mobile-menu, .mobile-meganav-source, [data-desktop-header], #mobile_menu';

  function isStuckLazy(el) {
    if (!el || !el.classList || !el.classList.contains('lazyload')) return false;
    if (el.classList.contains('lazyloaded')) return false;
    return !!(
      el.getAttribute('data-src') ||
      el.getAttribute('data-srcset') ||
      el.getAttribute('data-bg') ||
      el.getAttribute('data-bgset')
    );
  }

  function shouldSkip(el) {
    return !!(el.closest && el.closest(LAZY_SKIP));
  }

  /** Below-the-fold mobile cap; homepage hero uses 1200px via <picture> in homepage-hero-split. */
  var MOBILE_IMG_MAX = 800;

  function mobileSrc(url) {
    if (!url) return '';
    return String(url)
      .replace(/width=\d+/g, 'width=' + MOBILE_IMG_MAX)
      .replace(/_(\d+)x(?=\.|[?&]|$)/g, '_' + MOBILE_IMG_MAX + 'x');
  }

  function pickMobileSrc(el) {
    var srcset = el.getAttribute('data-srcset') || el.getAttribute('srcset') || '';
    var widths = [1200, 1000, 800, 600, 400];
    for (var i = 0; i < widths.length; i++) {
      var w = widths[i];
      if (w > MOBILE_IMG_MAX) continue;
      var match = srcset.match(new RegExp('(\\S+)\\s+' + w + 'w'));
      if (match) return match[1];
    }
    var src = el.getAttribute('data-src') || el.getAttribute('src') || '';
    return mobileSrc(src);
  }

  function isLcpImage(img) {
    if (!img) return false;
    if (img.getAttribute('fetchpriority') === 'high') return true;
    if (!img.classList) return false;
    return (
      img.classList.contains('hp-hero-split__img') ||
      img.classList.contains('collection-editorial-hero__img') ||
      img.classList.contains('collection-minimal-hero__img')
    );
  }

  function unveilEl(el) {
    if (!isStuckLazy(el) || shouldSkip(el)) return;

    if (isNarrow()) {
      var src = pickMobileSrc(el);
      var bg = el.getAttribute('data-bg') || el.getAttribute('data-mobile-bg');
      el.removeAttribute('srcset');
      el.removeAttribute('data-srcset');
      if (src) el.src = src;
      if (bg) el.style.backgroundImage = 'url(' + mobileSrc(bg) + ')';
      el.classList.remove('lazyload');
      el.classList.add('lazyloaded');
      return;
    }

    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      window.lazySizes.loader.unveil(el);
      return;
    }

    var srcset = el.getAttribute('data-srcset');
    var src = el.getAttribute('data-src');
    var bg = el.getAttribute('data-bg');
    if (srcset) el.setAttribute('srcset', srcset);
    if (src) el.setAttribute('src', src);
    if (bg) el.style.backgroundImage = 'url(' + bg + ')';
    el.classList.remove('lazyload');
    el.classList.add('lazyloaded');
  }

  function checkLazy() {
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
      window.lazySizes.loader.checkElems();
    }
  }

  function unveilStuck(forceRemaining) {
    var nodes = document.querySelectorAll('.lazyload');
    if (!nodes.length) return;

    checkLazy();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isStuckLazy(el) || shouldSkip(el)) continue;
      if (forceRemaining) {
        unveilEl(el);
      }
    }
  }

  function watchLazyImages() {
    if (!('IntersectionObserver' in window)) {
      unveilStuck(true);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          unveilEl(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    function observeStuck() {
      var nodes = document.querySelectorAll('.lazyload');
      for (var i = 0; i < nodes.length; i++) {
        if (isStuckLazy(nodes[i]) && !shouldSkip(nodes[i])) {
          observer.observe(nodes[i]);
        }
      }
    }

    observeStuck();

    if ('MutationObserver' in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.setTimeout(function () {
          scheduled = false;
          checkLazy();
          observeStuck();
        }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', function () {
      checkLazy();
      observeStuck();
    });
  }

  function bootMobileImages() {
    document.querySelectorAll('main img, #MainContent img').forEach(function (img) {
      if (shouldSkip(img)) return;
      if (isLcpImage(img)) return;
      // <picture> already pins a mobile source per media query — touching srcset here
      // would re-run selection and decode the image a second time.
      if (img.parentElement && img.parentElement.tagName === 'PICTURE') return;
      if ((img.getAttribute('src') || '').indexOf('data:') === 0 && !img.getAttribute('data-src')) return;
      var src = pickMobileSrc(img);
      if (!src || src.indexOf('data:') === 0) return;
      if (!img.getAttribute('srcset') && img.getAttribute('src') === src) return;
      img.removeAttribute('srcset');
      if (img.getAttribute('src') !== src) img.src = src;
    });

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.lazyload').forEach(unveilEl);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          unveilEl(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '80px 0px', threshold: 0.01 }
    );

    document.querySelectorAll('.lazyload').forEach(function (el) {
      if (isStuckLazy(el) && !shouldSkip(el)) observer.observe(el);
    });
  }

  function bootLazyImages() {
    if (isNarrow()) {
      bootMobileImages();
      return;
    }
    var onCollection = document.body && /\bcollection/.test(document.body.className || '');
    if (onCollection) return;

    checkLazy();
    if (window.lazySizes && typeof window.lazySizes.init === 'function') {
      window.lazySizes.init();
    }
    watchLazyImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLazyImages);
  } else {
    bootLazyImages();
  }

  window.addEventListener('load', function () {
    if (isNarrow()) return;
    window.setTimeout(function () {
      checkLazy();
      unveilStuck(false);
    }, 250);
  });

  window.addEventListener('pageshow', function () {
    if (isNarrow()) return;
    checkLazy();
    unveilStuck(false);
  });
})();
